/* import __COLOCATED_TEMPLATE__ from './move-intermediate-record-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class MoveIntermediateRecordComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked destinationEvent = null;
	@tracked timingPoints = [];
	@tracked destinationTimingPoint = null;
	@tracked recordID = null;
	
	@action
	async destinationEventChanged(browserEvent)
	{		
		if(browserEvent.target.value == '-')
		{
			this.destinationEvent = null;
		}
		else
		{
			const event = await this.store.findRecord('Event', browserEvent.target.value, { reload: true });
			this.destinationEvent = event;
			this.timingPoints = event.intermediateTimingPoints;
		}
	}
	
	@action
	async destinationTimingPointChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.destinationTimingPoint = null;
		}
		else
		{
			const timingPoint = await this.store.findRecord('IntermediateTimingPoint', browserEvent.target.value);
			this.destinationTimingPoint = timingPoint;
		}
	}
	
	@action
	async moveRecord()
	{	
		if(this.recordID != null)
		{
			const intermediateTimingRecord = await this.store.findRecord('IntermediateTimingRecord', this.recordID);
			
			intermediateTimingRecord.EventId = this.destinationEvent;
			intermediateTimingRecord.IntermediateTimingPointId = this.destinationTimingPoint;
			intermediateTimingRecord.EntryId = null;
			await intermediateTimingRecord.save();
			this.recordID = null;
		}
	}
}
